import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/tailwind.css'

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

window.onerror = function (message) {
    if (message.includes('Cannot find module') || message.includes('Loading chunk failed')) {
        // 检测到模块丢失，通常是版本更新了，引导用户或尝试自动刷新
        window.location.reload();
    }
};